import { combineReducers } from 'redux';
import { auth } from './auth';
import { accounts } from './accounts';
import { startApp } from '../actions/AppActions';
export const rootReducer = combineReducers({
  auth,
  accounts
});
export const initialState = rootReducer(undefined, startApp());